export enum WorkflowWidgetEventNames {
  BundleCreated = 'BundleCreated',
  BundleLoaded = 'BundleLoaded',
  ApplicationSubmit = 'ApplicationSubmit',
  LoanCreated = 'LoanCreated',
  NextButtonClicked = 'NextButtonClicked',
  PreviousButtonClicked = 'PreviousButtonClicked'
}

export enum WorkflowWidgetEventDataType {
  LoanEventData = 'LoanEventData',
  NavigationEventData = 'NavigationEventData',
  BundleEventData = 'BundleEventData'
}
